<template>
	<div id="account-share-form">
		<div id="account-share-header">
			<h4 class="title is-5">Account Sharing</h4>
			<template v-if="sharingEnabled">
				<button
					class="button is-light is-small has-text-primary"
					v-bind:class="{ 'is-loading' : newLinkLoading }"
					@click.prevent="makeNewLink">
					Create New Link
				</button>
				<button
					class="button is-light is-small has-text-danger"
					v-bind:class="{ 'is-loading' : loading }"
					@click.prevent="disableSharing">
					Disable Sharing
				</button>
			</template>
		</div>

		<b-field message="Share access to this account using the link above. Click on the clipboard icon to the left to copy the URL." v-if="sharingEnabled">
			<b-input
				id="share-link-input"
				@focus="selectShareLink"
				icon="clipboard"
				@icon-click="copyShareLink"
				:value="shareLink"
				readonly
				icon-clickable />
		</b-field>

		<b-message type="is-warning" v-else>
			<p>Sharing is currently disabled for this account.</p>

			<button
				class="button is-primary pull-right"
				v-bind:class="{ 'is-loading' : loading }"
				@click.prevent="enableSharing">
				Enable Sharing
			</button>
		</b-message>
	</div>
</template>

<script>
import {
  ACCOUNT_REFRESH_TOKEN
} from '@/store/actions/accounts'
import { FORM_UPDATE } from '../../store/actions/form'
import copy from 'copy-to-clipboard'

export default {

  data () {
    return {
      newLinkLoading: false,
      loading: false,
      shareLink: this.account.share_link,
      sharingEnabled: this.account.sharing_enabled
    }
  },

  props: {
    account: {
      type: Object
    }
  },

  methods: {
    makeNewLink () {
      this.$buefy.dialog.confirm({
        title: 'Create new link',
        message: 'Are you sure? The previous link will be disabled forever.',
        confirmText: 'Create New Link',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.newLinkLoading = true
          this.$store.dispatch(ACCOUNT_REFRESH_TOKEN, this.account.id).then(response => {
            this.shareLink = response.data.share_link
          }).finally(() => {
            this.newLinkLoading = false
          })
        }
      })
    },
    disableSharing () {
      const data = {
        id: this.account.id,
        model: 'accounts',
        fields: {
          sharing_enabled: false
        }
      }

      this.loading = true
      this.$store.dispatch(FORM_UPDATE, data).then(response => {
        this.sharingEnabled = false
        this.loading = false
        this.$awn.success('Sharing of this account is now disabled')
      }).catch(error => {
        console.error(error)
      })
    },
    enableSharing () {
      const data = {
        id: this.account.id,
        model: 'accounts',
        fields: {
          sharing_enabled: true
        }
      }

      this.loading = true
      this.$store.dispatch(FORM_UPDATE, data).then(response => {
        this.sharingEnabled = true
        this.loading = false
        this.$awn.success('Sharing of this account is now enabled')
      }).catch(error => {
        console.error(error)
      })
    },
    selectShareLink () {
      document.getElementById('share-link-input').select()
    },
    copyShareLink () {
      copy(this.shareLink)
      this.selectShareLink()
      this.$awn.info('The link has been copied to your clipboard ready to be shared.')
    }
  }
}
</script>

<style>
#share-link-input {
	background-color: #F5F5F5;
	border-color: #F5F5F5;
	box-shadow: none;
	color: #7A7A7A;
	border-radius: 4px;
}

#share-link-input:hover, #share-link-input:focus {
	border-color: #F5F5F5;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountShareForm.vue